import React from "react";
import Label from "../../../Form/Label";
import Select from "react-select";

const PropertyOverview = ({
  formData,
  setFormData,
  addSelectAllOption,
  basicAmenities,
  featuresAmenities,
  nearbyAmenities,
  selectedBasic,
  selectedFeatures,
  selectedNearby,
  handleSelectChange,
  sampleGuide,
}) => {
  return (
    <main className="flex w-full justify-between gap-6">
      <div className="bg-white h-fit  flex flex-col gap-3 rounded-[10px] p-[30px] w-[42%]">
        <div className="text-customGreen  text-[17px] mb-4 font-semibold">
          Section Layout
        </div>
        <img
          src={sampleGuide.propertyOverview}
          className="w-full"
          alt="Header and Hero Preview"
        />
      </div>
      <div className="bg-white overflow-x-auto min-h-72 rounded-[10px] p-[30px] flex-1">
        <div className="flex items-center justify-between flex-1 mb-8">
          <div className="text-customGreen text-[17px] font-semibold  ">
            Property Overview Section
          </div>

          <div className="flex ">
            <label className="inline-flex mb-5 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.propertyOverview.enable}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    propertyOverview: {
                      ...formData.propertyOverview,
                      enable: e.target.checked,
                    },
                  })
                }
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
            </label>
          </div>
        </div>
        <div className="text-customGreen font-semibold mb-4 ">Basic Info</div>
        <div className="flex flex-col gap-3">
          {/* <div className="flex justify-between gap-2">
                        <Label label={"Enable This Section"} />
                        <div className="flex ">
                          <label className="inline-flex mb-5 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.propertyOverview.enable}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  propertyOverview: {
                                    ...formData.propertyOverview,
                                    enable: e.target.checked,
                                  },
                                })
                              }
                              className="sr-only peer"
                            />
                            <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                          </label>
                        </div>
                      </div> */}
          {/* <div className="flex justify-between gap-2">
                        <Label label={"Property Name"} />
                        <div className="flex items-center justify-center w-[75%]">
                          <input
                            aria-label="Property name"
                            value={formData.propertyOverview.name}
                            readOnly
                            className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                          />
                        </div>
                      </div> */}

          <div className="flex justify-between gap-2">
            <Label label={"Property Description"} />
            <div className="flex items-center justify-center w-[75%]">
              <textarea
                value={formData.propertyOverview.description}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    propertyOverview: {
                      ...formData.propertyOverview,
                      description: e.target.value,
                    },
                  })
                }
                maxLength={1000}
                placeholder="Enter Description"
                className="w-full h-[200px] px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6 mt-6">
            <div className="flex items-center gap-4">
              <div className="w-1/2">
                <Label label={"Overall Area"} />
              </div>
              <div className="w-1/2">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={
                    formData.propertyOverview.overallArea === 0
                      ? ""
                      : formData.propertyOverview.overallArea
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          overallArea: parseInt(value) || 0,
                        },
                      });
                    }
                  }}
                  placeholder="Enter Area"
                  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                />
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-1/2">
                <Label label={"Average Price"} />
              </div>
              <div className="w-[22%]">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={
                    formData.propertyOverview.averagePrice.min === 0
                      ? ""
                      : formData.propertyOverview.averagePrice.min
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          averagePrice: {
                            ...formData.propertyOverview.averagePrice,
                            min: parseInt(value) || 0,
                          },
                        },
                      });
                    }
                  }}
                  placeholder="Min Price"
                  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                />
              </div>
              <div className="w-[25%]">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={
                    formData.propertyOverview.averagePrice.max === 0
                      ? ""
                      : formData.propertyOverview.averagePrice.max
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          averagePrice: {
                            ...formData.propertyOverview.averagePrice,
                            max: parseInt(value) || 0,
                          },
                        },
                      });
                    }
                  }}
                  placeholder="Max Price"
                  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                />
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-1/2">
                <Label label={"Average Unit SQ.FT"} />
              </div>
              <div className="w-[25%]">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={
                    formData.propertyOverview.averageUnitSqft.min === 0
                      ? ""
                      : formData.propertyOverview.averageUnitSqft.min
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          averageUnitSqft: {
                            ...formData.propertyOverview.averageUnitSqft,
                            min: parseInt(value) || 0,
                          },
                        },
                      });
                    }
                  }}
                  placeholder="Min Unit SQ.FT"
                  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                />
              </div>
              <div className="w-[23%]">
                <input
                  type="number"
                  value={
                    formData.propertyOverview.averageUnitSqft.max === 0
                      ? ""
                      : formData.propertyOverview.averageUnitSqft.max
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          averageUnitSqft: {
                            ...formData.propertyOverview.averageUnitSqft,
                            max: parseInt(value) || 0,
                          },
                        },
                      });
                    }
                  }}
                   onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                  placeholder="Max Unit SQ.FT"
                  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                />
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-1/2">
                <Label label={"Available Units"} />
              </div>
              <div className="w-1/2">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={
                    formData.propertyOverview.availableUnits === 0
                      ? ""
                      : formData.propertyOverview.availableUnits
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          availableUnits: parseInt(value) || 0,
                        },
                      });
                    }

                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  placeholder="Enter Available Units"
                  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                />
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-1/2">
                <Label label={"Launch Date"} />
              </div>
              <div className="w-1/2">
                <input
                  type="date"
                  value={formData.propertyOverview.launchDate}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      propertyOverview: {
                        ...formData.propertyOverview,
                        launchDate: e.target.value,
                      },
                    })
                  }
                  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                />
              </div>
            </div>
            {formData.propertyTypeName === "Villa" && (
              <>
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Configuration (BHK)"} />
                  </div>
                  <div className="w-1/2">
                    <input
                      type="number"
                      value={formData.propertyOverview.configuration}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 3) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              configuration: value,
                            },
                          });
                        }
                      }}
                     
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter Configuration (BHK)"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Possession Status"} />
                  </div>
                  <div className="w-1/2">
                    <select
                      value={formData.propertyOverview.constructionType}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          propertyOverview: {
                            ...formData.propertyOverview,
                            constructionType: e.target.value,
                          },
                        })
                      }
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    >
                      <option value="">Select Status</option>
                      <option value="Ready to Move">Ready to Move</option>
                      <option value="Under Construction">
                        Under Construction
                      </option>
                      <option value="Upcoming">Upcoming</option>
                    </select>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="text-customGreen font-semibold mt-4">Amenities</div>

          <div className="my-4 flex items-center justify-between gap-4">
            <div className="w-[25%]">
              <Label label="Basic Amenities" />
            </div>
            <div className="w-[78%]">
              <Select
                isMulti
                options={addSelectAllOption(basicAmenities)}
                value={selectedBasic}
                onChange={(e) => handleSelectChange(e, "basic")}
                className="w-full"
                placeholder="Select Basic Amenities"
              />
            </div>
          </div>
          <div className="my-4 flex items-center justify-between gap-4">
            <div className="w-[25%]">
              <Label label="Featured Amenities" />
            </div>
            <div className="w-[78%]">
              <Select
                isMulti
                options={addSelectAllOption(featuresAmenities)}
                value={selectedFeatures}
                onChange={(e) => handleSelectChange(e, "features")}
                className="w-full"
                placeholder="Select Featured Amenities"
              />
            </div>
          </div>
          <div className="my-4 flex items-center justify-between gap-4">
            <div className="w-[25%]">
              <Label label="Nearby Amenities" />
            </div>
            <div className="w-[78%]">
              <Select
                isMulti
                options={addSelectAllOption(nearbyAmenities)}
                value={selectedNearby}
                onChange={(e) => handleSelectChange(e, "nearby")}
                className="w-full"
                placeholder="Select Nearby Amenities"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PropertyOverview;
